import React, { useContext } from 'react'
import { Button, ButtonProps, CircularProgress } from '@mui/material'
import { Field, FieldProps } from 'formik'
import { space } from '../../styles'
import { FieldsContext } from './Form'

type EmailFieldProps = ButtonProps

const SubmitButton: React.FC<EmailFieldProps> = ({ style, children, ...props }) => {
   const { loading } = useContext(FieldsContext)
   return (
      <Field>
         {({ form }: FieldProps) => {
            const disabled: boolean = !form.isValid || loading || !form.dirty
            return (
               <Button
                  type="submit"
                  {...props}
                  disabled={disabled}
                  variant="contained"
                  style={{
                     ...style,
                     padding: 12,
                     marginBlock: space.xs,
                     fontSize: 17,
                  }}
                  endIcon={loading ? <CircularProgress size={'100%'} /> : null}
               >
                  {children}
               </Button>
            )
         }}
      </Field>
   )
}

export default SubmitButton
